import React from 'react';
import { AdminHeaderLink, AdminLink } from '../components/admin-area-menu-links';
import { adminAreaPathName, citizenDeletionTabLabel, citizenDeletionTabPathName } from '../admin-area-pathnames';
import { joinURL } from '../../../utilities';
import { citizenDeletionOrdersPathName, citizenDeletionSinglePathName } from './citizen-deletion-pathnames';

interface ICitizenDeletionMenuProps {
  canSeeSingleDeletion: boolean;
  canSeeOrders: boolean;
}

export function CitizenDeletionMenu({ canSeeSingleDeletion, canSeeOrders }: ICitizenDeletionMenuProps) {
  const ordersLink = joinURL('/', adminAreaPathName, citizenDeletionTabPathName, citizenDeletionOrdersPathName);

  return (
    <>
      <AdminHeaderLink to={joinURL('/', adminAreaPathName, citizenDeletionTabPathName)}>
        {citizenDeletionTabLabel}
      </AdminHeaderLink>
      {canSeeSingleDeletion && <AdminLink to={joinURL('/', adminAreaPathName, citizenDeletionTabPathName, citizenDeletionSinglePathName)}>Slet af borger</AdminLink>}
      {canSeeOrders && <AdminLink to={ordersLink}>Masseslet</AdminLink>}
        
    </>
  );
}
